import './styles.scss'
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { I18n } from 'react-redux-i18n'

import { deploySmartchat } from 'redux/smartchat/header/actions'
import ProcessesList from './ProcessesList'
import ProcessContent from './ProcessContent'
import { SimpleBanner } from 'components/Banners'
import InputControls from 'components/common/InputControls'
import ModalWrapper from 'components/ModalWrapper'
import { Button } from 'components/Form'
import { useIntersection } from 'hooks'
import Nixi1Spinner from 'components/Nixi1Spinner'

const Processes = () => {
  const { header, processesList, deployLoading, deployError, loading, error } = useSelector(store => store.smartchatHeader)
  const { push, location } = useHistory()
  const dispatch = useDispatch()
  const [isOpenDeployModal, setIsOpenDeployModal] = useState(false)
  const [isAdvanceModeEnabled, setIsAdvanceModeEnabled] = useState(false)
  const [entry, setNode] = useIntersection({})

  useEffect(() => {
    let isSubscribed = true

    if (isSubscribed && processesList.some(process => process.hasAutomation)) setIsAdvanceModeEnabled(true)

    return () => isSubscribed = false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processesList])

  if (loading) return <div className='containerSpinner' style={{ height:'100%' }}> <Nixi1Spinner height='15vh' /> </div>

  if (error) return <p className='error-message'>{I18n.t(error.message)}</p>

  return (
    <div
      className='processes'
      style={{
        paddingTop: header.applyPending && !entry ? '78px' : null
      }}
    >
      {header.applyPending && (
        <SimpleBanner
          className={`processes__banner ${!entry ? 'processes__banner--floating' : ''}`}
          title={I18n.t('dashboard_modified-actions')}
          subtitle={I18n.t('dashboard_apply-changes-train-bot')}
          buttonText={I18n.t('dashboard_apply-changes')}
          buttonAction={() => dispatch(deploySmartchat({ onFinish: value => setIsOpenDeployModal(value) }))}
          isSubmitting={deployLoading}
          isFloating={!entry}
        />
      )}
      <div
        ref={setNode}
        className='processes__mode-toggle'
        style={{
          paddingTop: header.applyPending ? '15px' : null
        }}
      >
        <InputControls
          label={I18n.t('dashboard_mode_advanced')}
          value={isAdvanceModeEnabled}
          onChange={setIsAdvanceModeEnabled}
          disabled={processesList.some(process => process.hasAutomation)}
          disabledMessage={I18n.t('smartchat_advancedMode_lock_message')}
        />
      </div>
      <div className='processes__container animated fadeIn'>
        <ProcessesList />
        <ProcessContent isAdvanceModeEnabled={isAdvanceModeEnabled} />
      </div>
      <ModalWrapper
        isOpen={isOpenDeployModal}
        toggle={() => setIsOpenDeployModal(!isOpenDeployModal)}
        contentClassName='smartchat-modal smartchat-modal--notification'
        body={
          <p style={{ textAlign: 'center', color: !deployError ? '#E87721' : null }}>
            {!deployError ? I18n.t('smartchat_deploy_successful') : I18n.t(deployError.message)}
          </p>
        }
        footer={deployError && (
          <div className='button-modal-wrapper'>
            <Button
              primary
              value={I18n.t('dashboard_virtual-assistant')}
              onClick={() => push(location.pathname.replace('smartchat', 'console'))}
            />
          </div>
        )}
      />
    </div>
  )
}

export default Processes
